import React, { Component } from "react";
import QuickOfferCard from "../QuickOfferCard";
import DefaultOfferCard from "../../molecules/DefaultOfferCard";
import { css } from "emotion";
import { menuStyle, selectedStyle } from "./style";

class QuickOfferSection extends Component {
	constructor() {
		super();
		this.state = {
			quick: true
		};
	}

	onChangeQuickSale(isQuick) {
		this.setState({ quick: isQuick });
	}

	render() {
		const { quick } = this.state;
		return (
			<>
				<div className="row">
					{window.screen.availWidth < 768 ? (
						<div className="col-xs-16">
							<div
								className={`col-xs-8 text-center ${css`
									${menuStyle(quick)};
								`}`}
								onClick={() => this.onChangeQuickSale(true)}
							>
								Rápida
								<br />
								{quick ? (
									<div
										className={`${css`
											${selectedStyle};
										`}`}
									/>
								) : null}
							</div>
							<div
								className={`col-xs-8 text-center ${css`
									${menuStyle(!quick)};
								`}`}
								onClick={() => this.onChangeQuickSale(false)}
							>
								Personalizada
								<br />
								{!quick ? (
									<div
										className={`${css`
											${selectedStyle};
										`}`}
									/>
								) : null}
							</div>
						</div>
					) : null}

					<div className={`${quick ? "col-xs-16" : "hidden-xs"} col-sm-8 col-md-8`}>
						<QuickOfferCard />
					</div>
					<div className={`${quick ? "hidden-xs" : "col-xs-16"} col-sm-8 col-md-8`}>
						<DefaultOfferCard />
					</div>
				</div>
			</>
		);
	}
}

export default QuickOfferSection;
